module.exports = "/img/sports_car.0f14229b.png";